import React from 'react';

import svg from './assets/icons-16-chevron-up.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconChevronUp = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-chevron-up" />
);
